//utils/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Example translation resources
const resources = {
  en: {
    translation: {
      home: "Home",
      aboutMe: "About Me",
      support: "Support",
      signOut: "Sign Out",
      aboutMe_p1:
        "Welcome to the Schedule Maker web app! I built this app to simplifycreating and managing schedules with ease and flexibility. Using Google Sign-In and email authentication, you can securely access your scheduling dashboard from anywhere.",
      aboutMe_p2:
        "I'm passionate about building simple tools that make daily workflows smoother. This app is an example of that philosophy — focusing on usability, responsiveness, and modern web practices.",
      ContactMe: "Contact Me",
      support_p1:
        "Have questions, bug reports, or feature requests? Please reach me in the mail below, and we'll get back to you as soon as possible.",
      support_p2:
        "And if you found it as helpful for you as it was for me, don't hesitate to let me know and support me with a coffee ☕ on PayPal.",
      page1_title: "Initial Setup",
      page1_days: "Number of Days",
      page1_people: "Number of People",
      page1_ShiftsperDay: "Shifts per Day",

      // Page1 additional translations
      defaultShift: "Day Shift",
      shift: "Shift",
      addShift: "Add Shift",
      deleteShift: "Delete shift",
      atLeastOneShift: "At least one shift required",
      defaultsForPeople: "Defaults for People",
      maxShiftsPerPerson: "Max Shifts per Person",
      minEmptyDaysBetweenShifts: "Min Empty Days Between Shifts",
      rememberSettings: "Remember my settings for next time",
      next: "Next",

      // EditParticipantDialog translations
      editParticipant: "Edit Participant",
      name: "Name",
      previous: "Previous",
      saveClose: "Save & Close",

      // NewScheduleButton translations
      new: "New",
      discardCurrentSchedule: "Discard Current Schedule?",
      unsavedChangesWarning:
        "If you continue, any unsaved changes will be lost. Are you sure you want to create a new schedule without saving?",
      cancel: "Cancel",
      yesContinue: "Yes, Continue",

      // P2ActionsBtns translations
      clear: "Clear",
      autocomplete: "Autocomplete",
      exportAsExcel: "Export as Excel",

      // ScheduleTable translations
      edit: "Edit",
      NAME: "NAME",
      total: "TOTAL",
      holiday: "HOLIDAY",
      collapse: "Collapse",
      expand: "Expand",

      clickToEditParticipant: "Click to edit participant",
      max: "max",
      cellTooltip:
        "Left click: toggle unavailable (click or drag), Right click: assign/clear shift",

      // Page0 translations
      welcome: "Welcome",
      userId: "User ID",
      addNewSchedule: "Add New Schedule",
      yourSchedules: "Your Schedules",
      loadingSchedules: "Loading your schedules...",
      noSchedulesYet: "No schedules yet",
      noSchedulesDescription:
        'Click "Add New Schedule" to create your first schedule',
      deleteConfirmation: "Are you sure you want to delete",
      editSchedule: "Edit Schedule",
      deleteSchedule: "Delete Schedule",
      shifts: "shifts",
      people: "people",
      days: "days",
      created: "Created",
      unknownDate: "Unknown date",
      schedule: "Schedule",

      //Page2
      "Schedule Table": "Schedule Table",
      "Left click: toggle unavailable (click or drag), Right click: assign/clear shift":
        "Left click: toggle unavailable (click or drag), Right click: assign/clear shift",
      "Clear Assignments": "Clear Assignments",
      "Clear All": "Clear All",
      Autocomplete: "Autocomplete",
      "Export to Excel": "Export to Excel",
      Save: "Save",
      TOTAL: "TOTAL",
      HOLIDAY: "HOLIDAY",
      "Edit Participant": "Edit Participant",
      Name: "Name",
      "Max shifts per person": "Max shifts per person",
      "Min empty days between shifts": "Min empty days between shifts",
      Cancel: "Cancel",
      "Save & Close": "Save & Close",
      Previous: "Previous",
      Next: "Next",
      "Please enter valid values": "Please enter valid values",
      Person: "Person",
      Schedule: "Schedule",
      "Untitled Schedule": "Untitled Schedule",
      "Edit Schedule Title": "Edit Schedule Title",
      "Schedule Title": "Schedule Title",
      shiftDisplayOptions: "Shift display options",
      delete: "Delete",
      Max: "Max",
      Rest: "Rest",
      Tips: "Tips",
      editTitle: "Edit title",
      "Vardion Logo": "Vardion Logo",
      "Click to add participants from history":
        "Click to add participants from history",
      "Drag to reorder": "Drag to reorder",
      "Single tap: toggle unavailable, Double tap: assign shift":
        "Single tap: toggle unavailable, Double tap: assign shift",
      "Left click: toggle unavailable, Right click: assign shift":
        "Left click: toggle unavailable, Right click: assign shift",
      rotateDeviceLandscape:
        "Please rotate your device to landscape mode for a better experience",
      couldNotLockOrientation: "Could not lock orientation:",
    },
  },
  gr: {
    translation: {
      // Landing Page
      "Get Started for Free": "ΞΕΚΙΝΑ ΣΗΜΕΡΑ ΔΩΡΕΑΝ",
      "Tired of messy calendars and endless back-and-forth? Vardion's got you covered. Build, share, and manage your weekly and monthly schedules with a ridiculously smart and easy-to-use tool that makes everyone happy.":
        "Βαρεθήκατε τα χαοτικά ημερολόγια και το ατελείωτο μπρος-πίσω; Το Vardion σάς καλύπτει. Δημιουργήστε, μοιραστείτε και διαχειριστείτε εβδομαδιαία και μηνιαία προγράμματα με ένα πανέξυπνο και εύχρηστο εργαλείο που ικανοποιεί τους πάντες.",
      "Stop dreading schedules. Start loving them.":
        "Κάντε την οργάνωση χαρά, όχι αγγαρεία.",

      Students: "Μαθητές / Φοιτητές",
      Organizations: "Οργανισμοί",
      "Assign your personel at the coresponding tast, fast and fairly.":
        "Αναθέστε το προσωπικό σας στη σωστή εργασία, γρήγορα και δίκαια.",

      "Stay on top of classes, assignments, and exams with a smart schedule.":
        "Μείνετε πάντα οργανωμένοι με μαθήματα, εργασίες και εξετάσεις χάρη σε ένα έξυπνο πρόγραμμα.",
      Teams: "Μικρές Ομάδες",
      "Coordinate projects and deadlines without the endless back-and-forth.":
        "Συντονίστε έργα και προθεσμίες χωρίς ατελείωτες συζητήσεις και μπερδέματα.",
      Managers: "Διευθυντές",
      "Easily manage clients, projects, and meetings in one place.":
        "Διαχειριστείτε εύκολα πελάτες, έργα και συναντήσεις σε ένα μέρος.",
      Families: "Οικογένειες",
      "Keep track of family events, chores, and activities with ease.":
        "Παρακολουθήστε οικογενειακά γεγονότα, δουλειές και δραστηριότητες με ευκολία.",
      "Public Sector": "Δημόσιος Τομέας",
      "Streamline schedules, resources, and workflows for government and public institutions.":
        "Οργανώστε εύκολα προγράμματα, πόρους και ροές εργασίας για δημόσιους φορείς και υπηρεσίες.",
      "Security Groups": "Σώματα Ασφαλείας",
      Hospitals: "Νοσοκομεία",
      Hotels: "Ξενοδοχεία",
      "Army Shifts": "Υπηρεσίες Στρατού",
      "Coast Guard": "Λιμενικό Σώμα",
      Firefighters: "Πυροσβέστες",
      More: "Περισσότερα",

      "Ready to take control of your schedules?":
        "Έτοιμοι να πάρετε τον έλεγχο των προγραμμάτων σας;",
      "Start Now": "Ξεκινήστε ΔΩΡΕΑΝ",
      "Complete your scheduled chores in minutes, not hours.":
        "Ολοκληρώστε τον προγραμματισμό σας σε λεπτά, όχι σε ώρες.",

      "Easily schedule guards, assign shifts, and manage rotations.":
        "Προγραμματίστε εύκολα φύλακες, αναθέστε βάρδιες και διαχειριστείτε κυκλικά ωράρια.",
      "Organize doctors, nurses, and staff schedules with precision.":
        "Οργανώστε με ακρίβεια τα προγράμματα γιατρών, νοσηλευτών και προσωπικού.",
      "Manage rotating personnel shifts and ensure smooth operations.":
        "Διαχειριστείτε τις κυκλικές βάρδιες προσωπικού και εξασφαλίστε ομαλή λειτουργία.",
      "Coordinate duty schedules and rotations for military units.":
        "Συντονίστε προγράμματα υπηρεσιών και κυκλικές βάρδιες για στρατιωτικές μονάδες.",
      "Streamline shifts and emergency readiness for coast guard teams.":
        "Βελτιστοποιήστε τις βάρδιες και την ετοιμότητα έκτακτης ανάγκης για τις ομάδες του λιμενικού.",
      "Manage on-call schedules, rotations, and emergency coverage.":
        "Διαχειριστείτε προγράμματα εφημεριών, κυκλικές βάρδιες και κάλυψη έκτακτων αναγκών.",
      "Adaptable to any organization needing fair and efficient scheduling.":
        "Προσαρμόζεται σε κάθε οργανισμό που χρειάζεται δίκαιο και αποδοτικό προγραμματισμό.",
      "Assign everyday shifts fairly, and distribute holidays evenly":
        "Αναθέστε τις καθημερινές βάρδιες δίκαια και μοιράστε τις αργίες ισότιμα.",
      // REVIEWS SECTION
      "Why People Love Us:": "Γιατί μας αγαπούν",
      "Made For You:": "Φτιαγμένο για εσένα",
      "What we do": "Τι προσφέρουμε",

      "Alexander the Great": "Μέγας Αλέξανδρος",
      "To conquer the world, one must first conquer chaos. With custom schedules and smart rules, my armies marched as if guided by the stars.":
        "Για να κατακτήσεις τον κόσμο, πρέπει πρώτα να κατακτήσεις το χάος. Με προσαρμοσμένα προγράμματα και έξυπνους κανόνες, οι στρατοί μου βάδιζαν σαν να καθοδηγούνταν από τα άστρα.",

      "Leonidas of Sparta": "Λεωνίδας της Σπάρτης",
      "A thousand warriors, three hundred at the Hot Gates. Order and discipline were everything—this tool would have made our stand immortal.":
        "Χίλιοι πολεμιστές, τριακόσιοι στις Θερμοπύλες. Η τάξη και η πειθαρχία ήταν το παν—αυτό το εργαλείο θα έκανε την αντίστασή μας αθάνατη.",

      "Florence Nightingale": "Φλόρενς Νάιτινγκεϊλ",
      "Hospitals thrive on order. This app’s ability to respect availability and days off ensures no nurse is overworked, and no patient left waiting.":
        "Τα νοσοκομεία ευημερούν με την τάξη. Η δυνατότητα της εφαρμογής να σέβεται τη διαθεσιμότητα και τις άδειες εξασφαλίζει ότι καμία νοσοκόμα δεν εξαντλείται και κανένας ασθενής δεν περιμένει.",

      "Julius Caesar": "Ιούλιος Καίσαρας",
      "I came, I saw, I delegated. Auto-scheduling saved me hours, giving me time to focus on empire—not paperwork.":
        "Ήρθα, είδα, ανέθεσα. Ο αυτόματος προγραμματισμός μου έσωσε ώρες, δίνοντάς μου χρόνο να επικεντρωθώ στην αυτοκρατορία—όχι στη γραφειοκρατία.",

      "Leonardo da Vinci": "Λεονάρντο ντα Βίντσι",
      "Genius lies in design. Unlimited shifts per day and precise custom rules make this a true masterpiece of organization.":
        "Η ιδιοφυΐα κρύβεται στον σχεδιασμό. Απεριόριστες βάρδιες την ημέρα και ακριβείς προσαρμοσμένοι κανόνες κάνουν αυτό το εργαλείο αληθινό αριστούργημα οργάνωσης.",

      "Winston Churchill": "Ουίνστον Τσώρτσιλ",
      "In times of great struggle, efficiency is victory. Exporting schedules with ease kept my teams coordinated when every second mattered.":
        "Σε περιόδους μεγάλου αγώνα, η αποτελεσματικότητα είναι νίκη. Η εύκολη εξαγωγή προγραμμάτων κράτησε τις ομάδες μου συντονισμένες όταν κάθε δευτερόλεπτο είχε σημασία.",

      "Napoleon Bonaparte": "Ναπολέων Βοναπάρτης",
      "Battles are won with strategy, not chaos. This app gives me the precision I demanded of every campaign.":
        "Οι μάχες κερδίζονται με στρατηγική, όχι με χάος. Αυτή η εφαρμογή μου δίνει την ακρίβεια που απαιτούσα σε κάθε εκστρατεία.",

      Cleopatra: "Κλεοπάτρα",
      "Ruling an empire requires balance. With smart rules and custom shifts, every detail of my court stayed in harmony.":
        "Η διακυβέρνηση μιας αυτοκρατορίας απαιτεί ισορροπία. Με έξυπνους κανόνες και προσαρμοσμένες βάρδιες, κάθε λεπτομέρεια της αυλής μου έμενε σε αρμονία.",

      "Nikola Tesla": "Νίκολα Τέσλα",
      "Efficiency is the true spark of progress. Auto-scheduling electrifies my workflow like a current flowing without resistance.":
        "Η αποτελεσματικότητα είναι η αληθινή σπίθα της προόδου. Ο αυτόματος προγραμματισμός ηλεκτρίζει τη ροή εργασίας μου σαν ρεύμα που ρέει χωρίς αντίσταση.",
      // What we do
      "Easily create schedules—daily, weekly, monthly, or fully custom":
        "Δημιουργήστε εύκολα προγράμματα, ημερήσια, εβδομαδιαία, μηνιαία ή πλήρως προσαρμοσμένα στις ανάγκες σας.",
      "Set individual availability so every person gets the right shifts":
        "Ορίστε ατομική διαθεσιμότητα ώστε κάθε άτομο να παίρνει τις σωστές βάρδιες",
      "Add smart rules—days off, max shifts, and other restrictions":
        "Προσθέστε έξυπνους κανόνες — ρεπό, μέγιστες βάρδιες και άλλους περιορισμούς",
      "Build unlimited shifts per day, tailored to your needs":
        "Δημιουργήστε απεριόριστες βάρδιες ανά ημέρα, προσαρμοσμένες στις ανάγκες σας",
      "Save time with auto-scheduling that respects your rules":
        "Εξοικονομήστε χρόνο με αυτόματο προγραμματισμό που τηρεί τους κανόνες σας.",
      "Export to Excel or save securely online—your choice":
        "Εξαγάγετε σε Excel ή αποθηκεύστε με ασφάλεια online - εσείς επιλέγετε.",

      // NavBar
      home: "Αρχική",
      aboutMe: "Σχετικά με εμένα",
      support: "Υποστήριξη",
      signOut: "Αποσύνδεση",
      "All rights reserved.": "Με επιφύλαξη παντός δικαιώματος.",
      aboutMe_p1:
        "Καλώς ήρθατε στην εφαρμογή Schedule Maker! Δημιούργησα αυτή την εφαρμογή για να απλοποιήσω τη δημιουργία και διαχείριση προγραμμάτων με ευκολία και ευελιξία. Με σύνδεση μέσω Google και ταυτοποίηση μέσω email, μπορείτε να έχετε ασφαλή πρόσβαση στο dashboard προγραμματισμού σας από οπουδήποτε.",
      aboutMe_p2:
        "Πάθος μου η δημιουργία εργαλείων που κάνουν την καθημερινότητα πιο εύκολη. Αυτή η εφαρμογή είναι ένα παράδειγμα αυτής της φιλοσοφίας — με έμφαση στην ευχρηστία, την ταχύτητα και τις σύγχρονες πρακτικές web.",
      ContactMe: "Επικοινωνήστε μαζί μου",
      support_p1:
        "Έχετε ερωτήσεις, αναφορές σφαλμάτων ή προτάσεις για νέες λειτουργίες; Επικοινωνήστε μαζί μου στο email παρακάτω και θα σας απαντήσω το συντομότερο δυνατό.",
      support_p2:
        "Και εάν σας φάνηκε όσο βοηθητικό ήταν και σε εμένα, μη διστάσετε να με ενημερώσετε στο pravitas.dev@gmail.com και να με υποστηρίξετε με ένα καφεδάκι ☕ στο paypal.",
      page1_title: "Αρχική ρύθμιση",
      page1_days: "Αριθμός ημερών",
      page1_people: "Αριθμός ατόμων",
      page1_ShiftsperDay: "Υπηρεσίες/Βάρδιες ανά μέρα",

      // Page1 Greek translations
      defaultShift: "Ημερήσια Βάρδια",
      shift: "Βάρδια",
      addShift: "Προσθήκη Βάρδιας",
      deleteShift: "Διαγραφή βάρδιας",
      atLeastOneShift: "Απαιτείται τουλάχιστον μία βάρδια",
      defaultsForPeople:
        "Προεπιλογές για Άτομα (Βασική αρχικοποίηση για όλους. Προσαρμόζεται για κάθε εναν μεμονομένα στην επόμενη σελίδα)",
      maxShiftsPerPerson: "Μέγιστες Βάρδιες ανά Άτομο",
      minEmptyDaysBetweenShifts: "Ελάχιστες Κενές Ημέρες Μεταξύ Βαρδιών",
      rememberSettings: "Να θυμάστε τις ρυθμίσεις μου για την επόμενη φορά",
      next: "Επόμενο",
      Add: "Προσθήκη",
      Title: "Τίτλος",

      // EditParticipantDialog Greek translations
      editParticipant: "Επεξεργασία Συμμετέχοντα",
      name: "Όνομα",
      previous: "Προηγούμενο",
      saveClose: "Αποθήκευση & Κλείσιμο",

      // NewScheduleButton Greek translations
      new: "Νέο",
      discardCurrentSchedule: "Απόρριψη του τρέχοντος προγράμματος;",
      unsavedChangesWarning:
        "Εάν συνεχίσετε, τυχόν μη αποθηκευμένες αλλαγές θα χαθούν. Είστε βέβαιοι ότι θέλετε να δημιουργήσετε ένα νέο πρόγραμμα χωρίς αποθήκευση;",
      cancel: "Ακύρωση",
      yesContinue: "Ναι, συνέχεια",

      // P2ActionsBtns Greek translations
      clear: "Εκκαθάριση",
      autocomplete: "Αυτόματη Συμπλήρωση",
      exportAsExcel: "Εξαγωγή σε αρχείο Excel",

      // ScheduleTable Greek translations
      edit: "Επεξεργασία",
      NAME: "ΟΝΟΜΑ",
      total: "ΣΥΝΟΛΟ",
      holiday: "ΑΡΓΙΑ",
      collapse: "Σύμπτυξη",
      expand: "Επέκταση",
      "Click to toggle holiday": "Κλικ για ορισμό ή κατάργηση αργίας",
      clickToEditParticipant: "Κλικ για επεξεργασία συμμετέχοντα",
      max: "μέγ",
      cellTooltip:
        "Αριστερό κλικ: εναλλαγή μη διαθεσιμότητας (κλικ ή σύρσιμο), δεξί κλικ: ανάθεση/αφαίρεση βάρδιας",

      // Page0 Greek translations
      welcome: "Καλώς ήρθατε",
      userId: "Αναγνωριστικό χρήστη",
      addNewSchedule: "Προσθήκη νέου προγράμματος",
      yourSchedules: "Τα προγράμματά σας",
      loadingSchedules: "Φόρτωση των προγραμμάτων σας...",
      noSchedulesYet: "Δεν υπάρχουν προγράμματα ακόμη",
      noSchedulesDescription:
        'Κάντε κλικ στο "Προσθήκη νέου προγράμματος" για να δημιουργήσετε το πρώτο σας πρόγραμμα',
      deleteConfirmation: "Είστε βέβαιοι ότι θέλετε να διαγράψετε το",
      editSchedule: "Επεξεργασία προγράμματος",
      deleteSchedule: "Διαγραφή προγράμματος",
      shifts: "βάρδιες",
      people: "άτομα",
      days: "ημέρες",
      created: "Δημιουργήθηκε",
      unknownDate: "Άγνωστη ημερομηνία",
      schedule: "Πρόγραμμα",
      sortBy: "Ταξινόμηση",
      "sort by Date": "Ημ/νια",
      "sort by Title": "Τίτλος",

      //Page2
      "Schedule Table": "Πίνακας Προγράμματος",
      "Left click: toggle unavailable (click or drag), Right click: assign/clear shift":
        "Αριστερό κλικ: εναλλαγή μη διαθεσιμότητας (κλικ ή σύρσιμο), Δεξί κλικ: ανάθεση/εκκαθάριση βάρδιας",
      "Clear Assignments": "Εκκαθάριση Αναθέσεων",
      "Clear All": "Εκκαθάριση Όλων",
      Autocomplete: "Αυτόματη συμπλήρωση",
      "Export to Excel": "Εξαγωγή σε Excel",
      Save: "Αποθήκευση",
      TOTAL: "ΣΥΝΟΛΟ",
      HOLIDAY: "ΑΡΓΙΑ",
      "Edit Participant": "Επεξεργασία Συμμετέχοντα",
      Name: "Όνομα",
      "Max shifts per person": "Μέγιστες βάρδιες ανά άτομο",
      "Min empty days between shifts": "Ελάχιστες κενές ημέρες μεταξύ βαρδιών",
      Cancel: "Ακύρωση",
      "Save & Close": "Αποθήκευση & Κλείσιμο",
      Previous: "Προηγούμενο",
      Next: "Επόμενο",
      "Please enter valid values": "Παρακαλώ εισάγετε έγκυρες τιμές",
      Person: "Άτομο",
      Schedule: "Πρόγραμμα",
      "Left click: toggle unavailable (click or drag)":
        "Αριστερό κλικ: εναλλαγή μη διαθεσιμότητας (κλικ ή σύρσιμο)",
      "Right click: assign/clear shift.": "Δεξί κλικ: ανάθεση/αφαίρεση βάρδιας",
      "Left click on the days to mark it as holiday":
        "Αριστερό κλικ στις ημέρες των επικεφαλίδων για να τις ορίσετε ως αργία",
      "Double tap: assign/clear shift":
        "Διπλό πάτημα: ανάθεση/αφαίρεση βάρδιας",
      "Right click: assign/clear shift": "Δεξί κλικ: ανάθεση/αφαίρεση βάρδιας",

      updated: "Ενημερώθηκε",

      Legend: "Υπόμνημα",
      Fullscreen: "Πλήρης Οθόνη",
      Exit: "Έξοδος",
      "Only initials": "Μόνο αρχικά",
      "As Numbers": "Ως αριθμούς",
      "Display as": "Προβολή ως: ",
      "Clear assignments with one click.\nDouble click to clear all table":
        "Καθαρίστε τις αναθέσεις με ένα κλικ.\nΚάντε διπλό κλικ για να καθαρίσετε ολόκληρο τον πίνακα.",
      "Autocomplete Assignments": "Αυτόματη συμπλήρωση αναθέσεων",
      "Download as Excel file": "Λήψη ως αρχείο Excel",

      "Manage Participants": "Διαχείριση συμμετεχόντων",
      "Add from History": "Προσθήκη από το Ιστορικό",
      "Select participants from your history to add to the current schedule":
        "Επιλέξτε συμμετέχοντες από προηγούμενα προγράμματα για να τους προσθέσετε στο τρέχον πρόγραμμα",
      "Deselect All": "Αποεπιλογή Όλων",
      "Select All": "Επιλογή Όλων",
      "All participants from your history are already in the current schedule.":
        "Όλοι οι συμμετέχοντες από το ιστορικό σας βρίσκονται ήδη στο τρέχον πρόγραμμα.",
      Remove: "Αφαίρεση",
      "Select current participants to remove from the schedule":
        "Επιλέξτε τους τρέχοντες συμμετέχοντες για αφαίρεση από το πρόγραμμα",
      "No current participants to replace.":
        "Δεν υπάρχουν τρέχοντες συμμετέχοντες προς αντικατάσταση.",
      Adding: "Προσθήκη",
      Removing: "Αφαίρεση",
      "Apply Changes": "Εφαρμογή Αλλαγών",
      "Untitled Schedule":
        "\u03a0\u03c1\u03cc\u03b3\u03c1\u03b1\u03bc\u03bc\u03b1 \u03c7\u03c9\u03c1\u03af\u03c2 \u03c4\u03af\u03c4\u03bb\u03bf",
      "Edit Schedule Title":
        "\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c4\u03af\u03c4\u03bb\u03bf\u03c5 \u03c0\u03c1\u03bf\u03b3\u03c1\u03ac\u03bc\u03bc\u03b1\u03c4\u03bf\u03c2",
      "Schedule Title":
        "\u03a4\u03af\u03c4\u03bb\u03bf\u03c2 \u03c0\u03c1\u03bf\u03b3\u03c1\u03ac\u03bc\u03bc\u03b1\u03c4\u03bf\u03c2",
      shiftDisplayOptions:
        "\u0395\u03c0\u03b9\u03bb\u03bf\u03b3\u03ad\u03c2 \u03b5\u03bc\u03c6\u03ac\u03bd\u03b9\u03c3\u03b7\u03c2 \u03b2\u03b1\u03c1\u03b4\u03b9\u03ce\u03bd",
      delete: "\u0394\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae",
      Max: "\u039c\u03ad\u03b3.",
      Rest: "\u039a\u03b5\u03bd\u03cc",
      Tips: "\u03a3\u03c5\u03bc\u03b2\u03bf\u03c5\u03bb\u03ad\u03c2",
      editTitle:
        "\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c4\u03af\u03c4\u03bb\u03bf\u03c5",
      "Vardion Logo":
        "\u039b\u03bf\u03b3\u03cc\u03c4\u03c5\u03c0\u03bf Vardion",
      "Click to add participants from history":
        "\u039a\u03bb\u03b9\u03ba \u03b3\u03b9\u03b1 \u03c0\u03c1\u03bf\u03c3\u03b8\u03ae\u03ba\u03b7 \u03c3\u03c5\u03bc\u03bc\u03b5\u03c4\u03b5\u03c7\u03cc\u03bd\u03c4\u03c9\u03bd \u03b1\u03c0\u03cc \u03c4\u03bf \u03b9\u03c3\u03c4\u03bf\u03c1\u03b9\u03ba\u03cc",
      "Drag to reorder":
        "\u03a3\u03cd\u03c1\u03b5\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03b1\u03bd\u03b1\u03b4\u03b9\u03ac\u03c4\u03b1\u03be\u03b7",
      "Single tap: toggle unavailable, Double tap: assign shift":
        "\u0388\u03bd\u03b1 \u03c0\u03ac\u03c4\u03b7\u03bc\u03b1: \u03b5\u03bd\u03b1\u03bb\u03bb\u03b1\u03b3\u03ae \u03bc\u03b7 \u03b4\u03b9\u03b1\u03b8\u03b5\u03c3\u03b9\u03bc\u03cc\u03c4\u03b7\u03c4\u03b1\u03c2, \u03b4\u03b9\u03c0\u03bb\u03cc \u03c0\u03ac\u03c4\u03b7\u03bc\u03b1: \u03b1\u03bd\u03ac\u03b8\u03b5\u03c3\u03b7 \u03b2\u03ac\u03c1\u03b4\u03b9\u03b1\u03c2",
      "Left click: toggle unavailable, Right click: assign shift":
        "\u0391\u03c1\u03b9\u03c3\u03c4\u03b5\u03c1\u03cc \u03ba\u03bb\u03b9\u03ba: \u03b5\u03bd\u03b1\u03bb\u03bb\u03b1\u03b3\u03ae \u03bc\u03b7 \u03b4\u03b9\u03b1\u03b8\u03b5\u03c3\u03b9\u03bc\u03cc\u03c4\u03b7\u03c4\u03b1\u03c2, \u03b4\u03b5\u03be\u03af \u03ba\u03bb\u03b9\u03ba: \u03b1\u03bd\u03ac\u03b8\u03b5\u03c3\u03b7 \u03b2\u03ac\u03c1\u03b4\u03b9\u03b1\u03c2",
      rotateDeviceLandscape:
        "\u03a0\u03b5\u03c1\u03b9\u03c3\u03c4\u03c1\u03ad\u03c8\u03c4\u03b5 \u03c4\u03b7 \u03c3\u03c5\u03c3\u03ba\u03b5\u03c5\u03ae \u03c3\u03b1\u03c2 \u03c3\u03b5 \u03bf\u03c1\u03b9\u03b6\u03cc\u03bd\u03c4\u03b9\u03b1 \u03b8\u03ad\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03ba\u03b1\u03bb\u03cd\u03c4\u03b5\u03c1\u03b7 \u03b5\u03bc\u03c0\u03b5\u03b9\u03c1\u03af\u03b1",
      couldNotLockOrientation:
        "\u0394\u03b5\u03bd \u03ae\u03c4\u03b1\u03bd \u03b4\u03c5\u03bd\u03b1\u03c4\u03cc \u03c4\u03bf \u03ba\u03bb\u03b5\u03af\u03b4\u03c9\u03bc\u03b1 \u03c0\u03c1\u03bf\u03c3\u03b1\u03bd\u03b1\u03c4\u03bf\u03bb\u03b9\u03c3\u03bc\u03bf\u03cd:",
    },
  },
};

const savedLanguage = localStorage.getItem("appLanguage") || "en";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage, // default language
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
